export const types = {
  NOTIFICATIONS_INIT: 'NOTIFICATIONS_INIT',
  NOTIFICATIONS_SUCCESS: 'NOTIFICATIONS_SUCCESS',
  NOTIFICATIONS_FAILURE: 'NOTIFICATIONS_FAILURE',
  SET_UNREAD_COUNT: 'SET_UNREAD_COUNT',
  DECREMENT_UNREAD_COUNT: 'DECREMENT_UNREAD_COUNT',
};
